import { render } from "./AgentLeadsWrapper.vue?vue&type=template&id=88ac5c4a&lang=pug"
import script from "./AgentLeadsWrapper.vue?vue&type=script&lang=js"
export * from "./AgentLeadsWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__